import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { MessagesGeneral, MessagesTitles, MessagesStatus } from '../../../models/messages';
import { HttpErrorResponse } from '@angular/common/http';
import { FormControl } from '@angular/forms';
import Swal from "sweetalert2";
import * as moment from 'moment';
import { ReportesService } from '../../../services/reportes/reportes.service';
import { FiltrosConciliacionMensual } from 'app/models/FiltrosConciliacionMensual';
import { DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';
import { environment } from 'environments/environment';
@Component({
  selector: 'app-listado-rep-conciliaciones',
  templateUrl: './listado-rep-conciliaciones.component.html',
  styleUrls: ['./listado-rep-conciliaciones.component.scss'],
  providers: [MessagesTitles, MessagesGeneral, MessagesStatus, DatePipe]
})
export class ListadoRepConciliacionesComponent implements OnInit {
  Label_id_soles=environment.ID_GUIA_SOLES;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  pageSizeOptions = [15, 20, 30, 50, 100, 200];
  displayedColumns = ['checked', 'idComprobante', 'CantCIF', 'Codigo_Planilla', 'Numero',
    'Moneda', 'VNPP', 'VNPP_ICLV', 'Fecha_de_Pago', 'Fecha_de_Pago_ICLV',];
  filterValues = { Moneda: '' };
  monedaFilter = new FormControl('');
  abrirDetalleConciliacion: boolean = false;
  loading: boolean;
  dataSource: any;
  planillas: any = [];
  DTOFiltrosConciliaciones: FiltrosConciliacionMensual = new FiltrosConciliacionMensual();

  constructor(private reporteService: ReportesService,
    private msgTitulos: MessagesTitles,
    private msgStatus: MessagesStatus, private datePipe: DatePipe) {
    this.DTOFiltrosConciliaciones.FechaInicial = this.datePipe.transform(moment().add(-30, 'day'), 'yyyy-MM-dd');
    this.DTOFiltrosConciliaciones.FechaFinal = this.datePipe.transform(moment(), 'yyyy-MM-dd');
  }

  ngOnInit() {
    this.filtradoCompElectronicos();
    this.monedaFilter.valueChanges
      .subscribe(
        Moneda => {
          this.filterValues.Moneda = Moneda;
          this.dataSource.filter = JSON.stringify(this.filterValues);
        }
      );
  }

  ExportTOExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.planillas);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    let fecha = new Date();
    XLSX.writeFile(wb, 'Reporte_Conciliacion' + fecha + '.xlsx');
  }

  filtradoCompElectronicos() {
    this.loading = true;
    this.DTOFiltrosConciliaciones.FechaInicial = this.datePipe.transform(this.DTOFiltrosConciliaciones.FechaInicial, 'yyyy-MM-dd')
    this.DTOFiltrosConciliaciones.FechaFinal = this.datePipe.transform(this.DTOFiltrosConciliaciones.FechaFinal, 'yyyy-MM-dd')
    console.log('this.DTOFiltrosConciliaciones', this.DTOFiltrosConciliaciones)
    this.reporteService.ObtenerListaConciliacionesMensual(this.DTOFiltrosConciliaciones)
      .subscribe(resp => {
        this.planillas = resp;
        this.dataSource = new MatTableDataSource(this.planillas);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.pageSizeOptions = [15, 20, 30, 50, 100, 200];
        this.loading = false;
      }, (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA CONCILIACION NO OBTENIDO. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      });
  }

  AbrirDetalleConciliacion(element: any) {
    this.reporteService.idDesembolso = element;
    this.abrirDetalleConciliacion = true;
  }

  CerrarPopUpDetalleConciliacion() {
    this.abrirDetalleConciliacion = false;
  }

}
